function hasAny(name, parts) {
    return parts.some((p) => name.includes(p));
}
export function detectFeatureFromNames(meshNameRaw, matNameRaw) {
    const mesh = String(meshNameRaw || "").toLowerCase().trim();
    const mat = String(matNameRaw || "").toLowerCase().trim();
    const name = `${mesh} ${mat}`;
    if (hasAny(name, ["eye", "iris", "pupil"]))
        return "eye";
    if (hasAny(name, ["mouth", "lip", "jaw"]))
        return "mouth";
    if (name.includes("horn")) {
        if (hasAny(name, ["left", "_l", ".l"]))
            return "horn_left";
        if (hasAny(name, ["right", "_r", ".r"]))
            return "horn_right";
        return "helmet";
    }
    if (hasAny(name, ["orb", "lens", "visor", "glass"]))
        return "orb";
    if (hasAny(name, ["top", "top strip", "top_strip", "circuit", "strip"])) {
        return "top_strip";
    }
    if (hasAny(name, ["side", "panel", "propulsion"])) {
        return "side_panel";
    }
    if (hasAny(name, [
        "helmet",
        "emissive",
        "glow",
        "shell",
        "faceplate",
        "plate",
        "neural",
    ])) {
        return "helmet";
    }
    // === STRUCTURE / SURFACE / INTERNAL CLASSIFICATION ===
    if (name.includes("occlud") || name.includes("hidden")) {
        return "internal";
    }
    if (name.includes("glass") && !name.includes("eye")) {
        return "glass_secondary";
    }
    if (name.includes("frame") ||
        name.includes("base") ||
        name.includes("shell") ||
        name.includes("core")) {
        return "structure";
    }
    if (name.includes("panel") ||
        name.includes("plate") ||
        name.includes("metal")) {
        return "surface";
    }
    if (name.includes("joint") ||
        name.includes("connector") ||
        name.includes("mount")) {
        return "mechanical";
    }
    return "unknown";
}
export function buildFeatureSummary(scan) {
    const grouped = {};
    for (const item of scan) {
        grouped[item.feature] = (grouped[item.feature] || 0) + 1;
    }
    const priority = [
        "eye",
        "mouth",
        "horn_left",
        "horn_right",
        "top_strip",
        "side_panel",
        "orb",
        "helmet",
        "unknown",
    ];
    const lines = ["🧠 Ava Feature Scan", ""];
    for (const key of priority) {
        if (grouped[key]) {
            lines.push(`• ${key}: ${grouped[key]} detected`);
        }
    }
    return lines.join("\n");
}
